import { render, staticRenderFns } from "./NameCard.vue?vue&type=template&id=7939bea0&scoped=true&"
import script from "./NameCard.vue?vue&type=script&lang=js&"
export * from "./NameCard.vue?vue&type=script&lang=js&"
import style0 from "./NameCard.vue?vue&type=style&index=0&id=7939bea0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7939bea0",
  null
  
)

export default component.exports